import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';

Vue.use(ElementUI)

import VueAwesomeSwiper from 'vue-awesome-swiper';
import 'swiper/dist/css/swiper.css'
// import 'swiper/swiper-bundle.css';

Vue.use(VueAwesomeSwiper)

Vue.config.productionTip = false

function rems() {
  function setRem() {
    let rootElement = document.documentElement;
    let rootElementWidth = rootElement.getBoundingClientRect().width;
    // rootElementWidth > 1900 && (rootElementWidth = 1900);
    let rem = rootElementWidth / 19.2;
    rootElement.style.fontSize = rem + "px";
  }
  setRem();
  let timer;
  window.addEventListener("resize", function () {
    timer && clearTimeout(timer);
    timer = setTimeout(setRem, 10);
  }, false);
}
rems()
const preventReClick = Vue.directive('preventReClick',{
	inserted: function(el, binding, vNode, oldVnode){
		el.addEventListener('click', () => {
			if(!el.disabled){
			    el.disabled = true
          setTimeout(() => {
                el.disabled = false
          }, 3000)
			}
		})
	}
})
Vue.use( preventReClick )
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
